<section
  class="solutions-people-filters"
  [class.solutions-people-filters--dialog]="layoutVariant() === 'dialog'">
  @if (categoryItems.length > 0) {
    <pwj-filters-box
      [panelVariant]="filtersBoxPanelVariant()"
      [dialogLayout]="layoutVariant() === 'dialog'"
          boxTitle="solutions.filters.category"
          boxIcon="grid-apps"
          filterQueryName="category_id"
          filtersType="radioButton"
          [filterItems]="categoryItems"
          [additionalQueryParams]="categoryFilterQueryParams" />
      }

      <pwj-filters-section
        [showDivider]="categoryItems.length > 0"
        titleKey="solutions.filters.experienceTitle"
        icon="clock">
        <div class="solutions-people-filters__experience-range">
          <p
            class="solutions-people-filters__experience-values"
            role="status"
            aria-live="polite"
            [attr.aria-label]="experienceRangeAriaLabel">
            <span class="solutions-people-filters__experience-values-label">
              {{ 'global.from' | translate }}
            </span>
            <span class="solutions-people-filters__experience-value">
              {{ minExperience }} {{ 'solutions.filters.experienceYears' | translate }}
            </span>
            <span class="solutions-people-filters__experience-values-label">
              {{ 'global.to' | translate }}
            </span>
            <span class="solutions-people-filters__experience-value">
              {{ maxExperience }} {{ 'solutions.filters.experienceYears' | translate }}
            </span>
          </p>

          <div class="solutions-people-filters__experience-fields">
            <input
              class="solutions-people-filters__experience-thumb solutions-people-filters__experience-thumb--left"
              type="range"
              [min]="experienceMin"
              [max]="experienceMax"
              [value]="minExperience"
              [step]="experienceStep"
              [attr.aria-label]="'solutions.filters.minExperience' | translate"
              (input)="onMinExperienceChange($event)" />
            <input
              class="solutions-people-filters__experience-thumb solutions-people-filters__experience-thumb--right"
              type="range"
              [min]="experienceMin"
              [max]="experienceMax"
              [value]="maxExperience"
              [step]="experienceStep"
              [attr.aria-label]="'solutions.filters.maxExperience' | translate"
              (input)="onMaxExperienceChange($event)" />

            <div class="solutions-people-filters__experience-slider">
              <div class="solutions-people-filters__experience-track"></div>
              <div
                class="solutions-people-filters__experience-fill"
                [style.left.%]="!isExperienceRtl ? experienceMinPercent : null"
                [style.right.%]="isExperienceRtl ? experienceMinPercent : null"
                [style.width.%]="experienceFillWidthPercent"></div>
              <p class="solutions-people-filters__experience-bound solutions-people-filters__experience-bound--min">
                {{ experienceMin }} {{ 'solutions.filters.experienceYears' | translate }}
              </p>
              <p class="solutions-people-filters__experience-bound solutions-people-filters__experience-bound--max">
                {{ experienceMax }} {{ 'solutions.filters.experienceYears' | translate }}
              </p>
            </div>
          </div>
        </div>
      </pwj-filters-section>

      <pwj-filters-section
        [showDivider]="true"
        titleKey="solutions.filters.tradeSectionTitle"
        icon="briefcase">
        <form class="solutions-people-filters__form" [formGroup]="filtersForm">
          <label class="solutions-people-filters__field solutions-people-filters__field--full">
            <input
              type="text"
              class="solutions-people-filters__input"
              formControlName="trade"
              [attr.placeholder]="'solutions.filters.tradePlaceholder' | translate" />
          </label>
        </form>
      </pwj-filters-section>

      <pwj-filters-section
        [showDivider]="true"
        titleKey="solutions.filters.bimSectionTitle"
        icon="tick-circle">
        <div class="solutions-people-filters__bim-row">
          <pwj-checkbox
            embedded
            [label]="'solutions.filters.bimReady'"
            [(ngModel)]="bimReady"
            (ngModelChange)="onBimReadyChange($event)"></pwj-checkbox>
        </div>
      </pwj-filters-section>
</section>
